import type { IQrGrid } from './IQrGrid';

/**
 * Розміщення кодових слів зигзагом парами стовпців справа наліво (стовпець синхронізації 6 пропускається), знизу вгору й згори вниз
 * по черзі; службові модулі оминаються, залишкові біти лишаються світлими. Змінює матрицю.
 */
export function placeCodewords(grid: IQrGrid, codewords: readonly number[]): void {
  const n = grid.size;
  let i = 0;
  for (let right = n - 1; right >= 1; right -= 2) {
    if (right === 6) right = 5;
    for (let vert = 0; vert < n; vert++) {
      for (let j = 0; j < 2; j++) {
        const x = right - j;
        const upward = ((right + 1) & 2) === 0;
        const y = upward ? n - 1 - vert : vert;
        if (!grid.fn[y * n + x] && i < codewords.length * 8) {
          grid.modules[y * n + x] = (((codewords[i >>> 3] ?? 0) >>> (7 - (i & 7))) & 1) !== 0;
          i++;
        }
      }
    }
  }
}

/** Умова інверсії модуля для маски 0–7 (ISO/IEC 18004 табл. 10; x — стовпець, y — рядок). */
function masked(mask: number, x: number, y: number): boolean {
  switch (mask) {
    case 0: return (x + y) % 2 === 0;
    case 1: return y % 2 === 0;
    case 2: return x % 3 === 0;
    case 3: return (x + y) % 3 === 0;
    case 4: return (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0;
    case 5: return ((x * y) % 2) + ((x * y) % 3) === 0;
    case 6: return (((x * y) % 2) + ((x * y) % 3)) % 2 === 0;
    default: return (((x + y) % 2) + ((x * y) % 3)) % 2 === 0;
  }
}

/** Маска на всі неслужбові модулі (XOR; повторне застосування тієї самої маски знімає її). Змінює матрицю. */
export function applyMask(grid: IQrGrid, mask: number): void {
  const n = grid.size;
  for (let y = 0; y < n; y++) {
    for (let x = 0; x < n; x++) if (!grid.fn[y * n + x] && masked(mask, x, y)) grid.modules[y * n + x] = !grid.modules[y * n + x];
  }
}
